module.exports = __webpack_public_path__ + "img/profile2.827243d9.jpg";